import React from "react";

import { FeeBadgeWrapper } from "./FeeBadge.styles";
import PropTypes from "prop-types";
import "animate.css";

const FeeBadge = ({ message }) => {
  return (
    <FeeBadgeWrapper className="animate__fadeInDown">
      <p className="fee__price-label"> Tarifa DdC</p>
      <div className="fee__alert-container">
        <span className="fee_icon">ℹ️</span>
        <p className={`fee__label`}>{message}</p>
      </div>
    </FeeBadgeWrapper>
  );
};

FeeBadge.propTypes = {
  feePriceTraditional: PropTypes.string,
  messageTraditional: PropTypes.string,
  feePriceNonTraditional: PropTypes.string,
  messageNonTraditional: PropTypes.string,
};

export default FeeBadge;
